export interface CreateAccountData {
    email: string;
    password: string;
    password2: string;
    name: string;
}

export interface CreateUserResponse {
    emailVerificationToken: string;
}

export interface EmailVerificationResponse {
    email: string;
    emailVerified: boolean;
}

export interface VerifyEmailData {
    code: string;
}

export interface AddEmailRequest {
    email: string
}

export enum AddEmailResponseStatus {
    USED,
    OK
}

export interface AddEmailResponse {
    status: AddEmailResponseStatus;
    emailVerificationToken: string;
}

export interface AddVerifyEmailData extends VerifyEmailData {
    verificationToken: string;
}

export enum SmartIdAttachStatus {
    SUCESS,
    EXISTS
}

export interface SmartIdAttachResponse {
    status: SmartIdAttachStatus;
    verificationCode?: string;
}

export interface ResetPasswordTokenModel {
    jti: string;
    sub: string;
    exp: number;
}

export interface ResetPasswordVerifyRequestDto {
    pwd1: string;
    pwd2: string;
}
